import { CampaignAccess } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/access',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const { campaignId } = Route.useParams()

	return <CampaignAccess campaignId={campaignId} />
}
